import axios from 'axios';

/**
 * Simple API for disclaimers retrieval
 * @returns {Promise<any|{}>}
 */
export async function getDisclaimers() {
  const response = await axios.get('/api/disclaimers', {
    _hideErrors: true,
  });
  return response.data || {};
}